/* eslint-disable no-underscore-dangle */
import {
  ElementNode,
  $createParagraphNode,
  RangeSelection,
  SerializedElementNode,
  Spread,
  EditorConfig,
  LexicalEditor,
  ParagraphNode,
  DOMConversionMap,
} from 'lexical';

import { $convertCodeBlockElement, $createCodeBlockNode } from './helpers';

export type SerializedCodeBlockNode = Spread<
  {
    version: 1;
    textFormat: number;
    textStyle: string;
  },
  SerializedElementNode
>;

export class CodeBlockNode extends ElementNode {
  createDOM(_config: EditorConfig, editor: LexicalEditor): HTMLElement {
    const div = document.createElement('div');
    div.classList.add('editor-code-block');
    div.setAttribute('contenteditable', String(editor._editable));

    // Добавляем placeholder, если нода пуста
    this.updatePlaceholder(div);

    return div;
  }

  updatePlaceholder(dom: HTMLElement): void {
    const placeholder = dom.querySelector('.editor-code-block-placeholder');
    if (this.isEmpty()) {
      if (!placeholder) {
        const placeholderDiv = document.createElement('div');
        placeholderDiv.classList.add('editor-code-block-placeholder');
        placeholderDiv.textContent = 'Добавьте код';
        dom.appendChild(placeholderDiv);
      }
    } else if (placeholder) {
      dom.removeChild(placeholder);
    }
  }

  static clone(node: CodeBlockNode): CodeBlockNode {
    return new CodeBlockNode(node.__key);
  }

  static getType(): string {
    return 'code-block-node';
  }

  static importDOM(): DOMConversionMap | null {
    return {
      div: () => ({
        conversion: $convertCodeBlockElement,
        priority: 0,
      }),
    };
  }

  updateDOM(_prevNode: unknown, dom: HTMLElement): boolean {
    // Обновляем placeholder при изменении содержимого
    this.updatePlaceholder(dom);

    return false; // Возвращаем false, чтобы Lexical не заменял DOM
  }

  insertNewAfter(
    rangeSelection: RangeSelection,
    restoreSelection: boolean,
  ): ParagraphNode {
    const newElement = $createParagraphNode();
    newElement.setTextFormat(rangeSelection.format);
    newElement.setTextStyle(rangeSelection.style);
    const direction = this.getDirection();
    newElement.setDirection(direction);
    newElement.setFormat(this.getFormatType());
    newElement.setStyle(this.getStyle());
    this.insertAfter(newElement, restoreSelection);

    return newElement;
  }

  static importJSON(serializedNode: SerializedCodeBlockNode): CodeBlockNode {
    return $createCodeBlockNode().updateFromJSON(serializedNode);
  }

  exportJSON(): SerializedCodeBlockNode {
    return {
      ...super.exportJSON(),
      type: this.getType(),
      version: 1,
      textFormat: this.getTextFormat(),
      textStyle: this.getTextStyle(),
    };
  }
}
